module.exports = __webpack_public_path__ + "img/checkbook.72f002c8.png";